import { router } from 'ui-utilities';
import { getSpamTokens } from '../helpers/spam-protection';

export default function RebateForm(el, {
    recaptchaSiteKey,
    turnstileSiteKey,
    gaSubmissionEvent,
    actions,
    events,
}) {
    const form = el.querySelector('form');
    const submit = form.querySelector('[type="submit"]');
    const closeButton = el.querySelector('button[data-close]');

    if (!form) return;

    function handleFormSubmit(e) {
        e.preventDefault();

        submit.setAttribute('disabled', true);

        const formData = new FormData(form);

        getSpamTokens({
            recaptchaSiteKey,
            turnstileSiteKey,
            action: 'rebateDownload',
            container: form,
        }).then(({ recaptchaToken, turnstileToken }) => {
            formData.set('recaptchaToken', recaptchaToken);
            formData.set('turnstileToken', turnstileToken);

            function cb(res) {
                // Reset all field errors to empty
                Array.from(formData.keys()).forEach(name => {
                    events.emit(actions.showInputErrors, {
                        name,
                        errors: [],
                        formId: 'rebateDownload',
                    });
                });
                submit.removeAttribute('disabled');

                const { success, errors = [] } = JSON.parse(res);

                if (!success) {
                    Object.entries(errors).forEach(([name, errs]) => {
                        events.emit(actions.showInputErrors, {
                            name,
                            errors: errs,
                            formId: 'rebateDownload',
                        });
                    });

                    return;
                }

                /* eslint-disable no-undef */
                if (typeof dataLayer === 'object' && gaSubmissionEvent) {
                    dataLayer.push({
                        event: 'huberwoodevents',
                        ...gaSubmissionEvent,
                    });
                }
                /* eslint-enable no-undef */

                events.emit(actions.startDownload);
                events.emit(actions.unlockScroll);
            }

            router.post({ formData, cb });
        }).catch(err => {
            submit.removeAttribute('disabled');
            console.error('Spam protection error:', err);
            window.alert('Verification failed. Please try again.');
        });
    }

    form.addEventListener('submit', handleFormSubmit);
    closeButton.addEventListener('click', () => {
        closeButton.parentElement.classList.toggle('show');
        events.emit(actions.unlockScroll);
    });
}
